import { Skeleton, Stack, type SxProps, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export interface BayerLookupProps {
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    body?: string | ReactNode;
    overline?: string | ReactNode;
    showSkeleton?: boolean;
    size?: 'lg' | 'md';
    color?: 'primary' | 'white';
    sx?: SxProps;
    titleIcon?: ReactNode;
}

const BayerLookup = ({
    title,
    subtitle,
    body,
    overline,
    showSkeleton = false,
    size = 'md',
    color = 'primary',
    sx,
    titleIcon,
}: BayerLookupProps) => {
    let titleVariant = 'h4';
    const subtitleVariant = 'h5';
    const bodyVariant = 'body1';

    if (size === 'lg') {
        titleVariant = 'h2';
    }
    return (
        <Stack direction='column' spacing={1} sx={sx}>
            {overline && (
                <Typography
                    variant='overline'
                    color={color === 'primary' ? 'primary.mui.inactive' : 'white'}
                    textTransform='uppercase'
                >
                    {overline}
                </Typography>
            )}
            <Stack direction='row' spacing={1} alignItems='center'>
                <Typography variant={titleVariant} color={color}>
                    {showSkeleton ? <Skeleton width={100} variant='text' /> : title}
                </Typography>
                {titleIcon && titleIcon}
            </Stack>
            {subtitle && (
                <Typography variant={subtitleVariant} color={color}>
                    {showSkeleton ? <Skeleton width={200} variant='text' /> : subtitle}
                </Typography>
            )}
            {body && (
                <Typography variant={bodyVariant} color={color}>
                    {showSkeleton ? <Skeleton width={200} variant='text' /> : body}
                </Typography>
            )}
        </Stack>
    );
};

export default BayerLookup;
